// React
import React, { useState, useCallback, useEffect } from "react";

// Libraries
import PropTypes from "prop-types";
import { reduce, orderBy, map, flatten, debounce, isEmpty } from "lodash";
import { Icon } from "semantic-ui-react";
import moment from "moment";

// Redux
import { connect } from "react-redux";
import genericAction from "@Redux/Actions/generic";
import { clearSearchMessages } from "@Redux/Actions/chats";

// Utils
import { dateSort } from "@Utils";

// Components
import Input from "@Components/Input";
import SearchMessageList from "../SearchMessageList";

// Hooks
import usePanelVisibility from "@Hooks/usePanelVisibility";

// Styles
import styles from "./styles.module.css";

const SearchMessages = ({ dispatch, channelCid, currentChat }) => {
	const { goList, goChat, isMobile } = usePanelVisibility();
	const [search, setSearch] = useState("");
	const [sectionsData, setSectionsData] = useState([]);
	const [messagesData, setMessagesData] = useState([]);
	const [dataCounts, setDataCounts] = useState([]);

	useEffect(() => {
		if (!isEmpty(search)) {
			handleSearch(channelCid, search);
		}
	}, [search]);

	const handleInput = (e) => {
		const { value } = e.target;
		setSearch(value);
	};

	const handleClear = () => {
		dispatch(clearSearchMessages());
		if (isMobile) {
			goChat();
		} else {
			goList();
		}
	};

	const handleSearch = useCallback(
		debounce(async (id, text) => {
			const data = await dispatch(genericAction({ method: "post", route: "/chats/searchMessages", body: { channelCid: id, text } }));
			const mappedData = map(data, (item) => {
				return { ...item, status: "read" };
			});
			const groups = reduce(
				orderBy(mappedData, "timestamp", "desc"),
				(acum, item) => {
					const date = item.createdDate.split("T")[0];
					if (!acum[date]) {
						acum[date] = [];
					}
					acum[date].unshift(item);
					return acum;
				},
				{}
			);
			const groupArrays = Object.keys(groups)
				.sort(dateSort)
				.map((date) => {
					return { title: moment(date).format("MMMM D, YYYY"), items: groups[date] };
				});
			const groupCounts = map(groupArrays, (group) => {
				return group.items.length;
			});
			const sectionData = map(groupArrays, (group) => {
				return group.title;
			});
			const messageData = flatten(
				map(groupArrays, (group) => {
					return group.items;
				})
			);
			setSectionsData(sectionData);
			setMessagesData(messageData);
			setDataCounts(groupCounts);
		}, 1000),
		[]
	);

	return (
		<div className={styles.container}>
			<div className={styles.searchContainer}>
				<Input rounded icon="search" placeholder="Buscar Mensaje" value={search} onChange={handleInput} />
				<div className={styles.backIcon} tabIndex={-1} role="button" onClick={handleClear}>
					<Icon link name="close" />
				</div>
			</div>
			<div className={styles.listContainer}>
				<SearchMessageList sectionsData={sectionsData} messagesData={messagesData} dataCounts={dataCounts} currentChat={currentChat} />
			</div>
		</div>
	);
};

SearchMessages.propTypes = {
	dispatch: PropTypes.func,
	channelCid: PropTypes.string,
	currentChat: PropTypes.object,
};

export default connect()(SearchMessages);
